/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import AddIcon from '@mui/icons-material/Add';
import {Button, TableCell, TableRow} from '@mui/material';
import {useFlags} from 'launchdarkly-react-client-sdk';
import {FeatureFlagSet, FeatureFlags} from '../../../../flags';

interface EmptyTableRowProps {
  canCreateAgent: boolean;
  onCreateAgent: () => void;
}

export const EmptyTableRow = ({canCreateAgent, onCreateAgent}: EmptyTableRowProps) => {
  const flags = useFlags<FeatureFlagSet>();
  const showTestButton = flags[FeatureFlags.testAgent];
  const colSpan = showTestButton ? 4 : 3;

  return canCreateAgent ? (
    <TableRow>
      <TableCell colSpan={colSpan} align={'center'}>
        <Button variant={'text'} color={'primary'} onClick={onCreateAgent} startIcon={<AddIcon />}>
          Create an Agent
        </Button>
      </TableCell>
    </TableRow>
  ) : (
    <TableRow>
      <TableCell colSpan={colSpan} align={'center'}>
        No Agents Found
      </TableCell>
    </TableRow>
  );
};
